import { DecimalPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ShowFilterButtonComponent } from '@web/shared/ui';
import { SortV1Component } from '../sort/sort-v1.component';
import { Sort } from '../../models/sort.models';
import { Product } from '@uc/web/shared/data-models';

@Component({
	selector: 'uc-filter-sort-widget',
	templateUrl: './filter-sort-widget.component.html',
	imports: [NgClass, ShowFilterButtonComponent, DecimalPipe, SortV1Component],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterSortWidgetComponent {
	total = input.required<number>();
	totalPills = input.required<number>();
	text = input.required<string>();
	studyLevel = input<Product>();
	sortOptions = input<Sort[]>();
	selectedSortOption = input<Sort>();

	sort = output<Sort>();
	toggleFilter = output<boolean>();
}
